import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const InstitutionStudentEnrollment = loadable(
  () => import('./InstitutionStudentEnrollment'),
  {},
);
export const SendToSign = loadable(() => import('./SendToSign'), {});
export const Update = loadable(() => import('./Update'), {});
